module.exports = __webpack_public_path__ + "static/img/logo_horizontal_layout.e486ce3.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/logo_horizontal_layout.png
// module id = ae5S
// module chunks = 1